<app-page-header [title]="'Gestión de Eventos'" [subtitle]="'Módulo de gestión de eventos para las modalidades'"></app-page-header>

<div class="card">
  <p-tabView
    styleClass="tabview-custom"
    [(activeIndex)]="modalitieTabIndex"
    (onChange)="onModalitieTabChange($event)"
  >
    <p-tabPanel header="ARTISTICO">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <p-avatar image="./assets/img/iconArtistico.jpeg" shape="circle" />
          <span class="font-bold white-space-nowrap m-0"> Artístico </span>
        </div>
      </ng-template>
      <div *ngIf="showCompetitions" class="p-mt-2">
        <app-competitions-table
          [competitions]="competitions"
          [categories]="categories"
          [levels]="levels"
          [modalidad]="modalitieSelected"
          [events]="events"
        ></app-competitions-table>
      </div>
    </p-tabPanel>
    <p-tabPanel header="CARRERAS">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <p-avatar image="./assets/img/iconCarreras.jpeg" shape="circle" />
          <span class="font-bold white-space-nowrap m-0"> Carreras </span>
        </div>
      </ng-template>
      <div *ngIf="showCompetitions" class="p-mt-2">
        <app-competitions-table
          [competitions]="competitions"
          [categories]="categories"
          [levels]="levels"
          [modalidad]="modalitieSelected"
          [events]="events"
        ></app-competitions-table>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Header III">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <p-avatar image="./assets/img/iconHockey.jpeg" shape="circle" />
          <span class="font-bold white-space-nowrap m-0"> Hockey </span>
        </div>
      </ng-template>
      <div *ngIf="showCompetitions" class="p-mt-2">
        <app-competitions-table
          [competitions]="competitions"
          [categories]="categories"
          [levels]="levels"
          [modalidad]="modalitieSelected"
          [events]="events"
        ></app-competitions-table>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Header IV">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <p-avatar image="./assets/img/iconSkate.jpeg" shape="circle" />
          <span class="font-bold white-space-nowrap m-0"> Skateboarding </span>
        </div>
      </ng-template>
      <div *ngIf="showCompetitions" class="p-mt-2">
        <app-competitions-table
          [competitions]="competitions"
          [categories]="categories"
          [levels]="levels"
          [modalidad]="modalitieSelected"
          [events]="events"
        ></app-competitions-table>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
